(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
			this.headerTransparent = this.header.querySelector('.header-transparent');
				
			if(this.headerTransparent){
				const setTopPosition = () => { 
					this.headerTopPosition = this.header.offsetHeight;
					this.header.style.marginBottom = `-${this.header.offsetHeight}px`;
				}

				// setTopPosition();
				requestAnimationFrame(setTopPosition);

				let resizeTimeout;
				window.addEventListener('resize', () => {
					clearTimeout(resizeTimeout);
					resizeTimeout = setTimeout(setTopPosition, 60);
				});

				document.body.classList.add('header-transparent-active');
      } 

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop === 0 ) {
				this.classList.add('header-at-top');
			} else {
				this.classList.remove('header-at-top');
			}		

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const transparentHeader = document.querySelector('.header-transparent');
    if (transparentHeader) {
      const headerHeight = transparentHeader.offsetHeight;
      transparentHeader.style.marginBottom = `-${headerHeight}px`;
    }
  });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
if (!customElements.get('nzph-collection-directory')) {
  customElements.define('nzph-collection-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.directoryReady) return;
      this.directoryReady = true;
      const input = this.querySelector('[data-directory-filter]');
      const cards = [...this.querySelectorAll('[data-directory-card]')];
      const empty = this.querySelector('[data-directory-empty]');
      input.addEventListener('input', () => {
        const term = input.value.trim().toLocaleLowerCase();
        let visible = 0;
        cards.forEach(card => {
          card.hidden = !card.dataset.directoryName.toLocaleLowerCase().includes(term);
          if (!card.hidden) visible++;
        });
        empty.hidden = visible !== 0;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description-expanded"]) return;
  try {
    
  if (!customElements.get('nzph-product-description')) {
    customElements.define('nzph-product-description', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced) return;
        const source = this.querySelector('[data-description-source]');
        if (!source) return;
        const headingSelector = 'h2, h3, h4, h5, h6';
        const sectionPattern = /^(ingredients?|composition|nutritional (information|facts)|dosage|directions(?: for use)?|recommended (use|dosage)|how to (use|take)|cautions?|warnings?|precautions?|safety(?: information)?|more info(?:rmation)?|further information|research|additional information|faqs?|frequently asked questions)\s*[:：]?$/i;
        const cautionPattern = /^(cautions?|warnings?|precautions?|safety)/i;
        const flatten = (parent) => {
          const nodes = [];
          for (const node of Array.from(parent.childNodes)) {
            if (node.nodeType === 1 && node.tagName === 'DIV' && node.querySelector(headingSelector)) {
              nodes.push(...flatten(node));
            } else {
              nodes.push(node);
            }
          }
          return nodes;
        };
        const nodes = flatten(source);
        const hasSections = nodes.some(node =>
          node.nodeType === 1 && node.matches(headingSelector) &&
          sectionPattern.test(node.textContent.trim())
        );
        const normalizeHeading = (node, level) => {
          const heading = document.createElement(level);
          for (const attribute of Array.from(node.attributes)) {
            if (attribute.name !== 'style') heading.setAttribute(attribute.name, attribute.value);
          }
          while (node.firstChild) heading.appendChild(node.firstChild);
          return heading;
        };
        if (!hasSections) {
          source.querySelectorAll('h5, h6').forEach(node =>
            node.replaceWith(normalizeHeading(node, node.tagName === 'H5' ? 'h2' : 'h3'))
          );
          this.dataset.enhanced = 'true';
          return;
        }
        const overview = document.createElement('div');
        overview.className = 'product-description-expanded__overview rte';
        const detailGroup = document.createElement('div');
        detailGroup.className = 'product-description-expanded__details';
        let target = overview;
        for (let node of nodes) {
          const isHeading = node.nodeType === 1 && node.matches(headingSelector);
          const title = isHeading ? node.textContent.trim() : '';
          if (isHeading && sectionPattern.test(title)) {
            const detail = document.createElement('details');
            detail.className = 'product-description-expanded__accordion';
            if (cautionPattern.test(title)) {
              detail.open = true;
              detail.classList.add('is-caution');
            }
            const summary = document.createElement('summary');
            summary.appendChild(normalizeHeading(node, 'h3'));
            detail.appendChild(summary);
            target = document.createElement('div');
            target.className = 'product-description-expanded__panel rte';
            detail.appendChild(target);
            detailGroup.appendChild(detail);
          } else {
            if (isHeading && (node.tagName === 'H5' || node.tagName === 'H6')) {
              node = normalizeHeading(node, node.tagName === 'H5' ? 'h2' : 'h3');
            }
            target.appendChild(node);
          }
        }
        const hasOverview = overview.textContent.trim() || overview.querySelector('img, table, video, iframe');
        this.replaceChildren();
        if (hasOverview) this.appendChild(overview);
        else this.classList.add('details-only');
        this.appendChild(detailGroup);
        this.classList.add('is-enhanced');
        this.dataset.enhanced = 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
